import React, { useState, useEffect } from "react";
import linkIcon from "../../../../assets/images/link.svg";
import editIcon from "../../../../assets/images/editIcon.svg";
import downloadIcon from "../../../../assets/images/download.svg";
import { useNavigate } from "react-router-dom";
// import { getCompanyType } from '../../../../redux/authSlice'
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchCompanyCertificateDetails,
  getCompanyDetailsById,
  getPendingCompanyDetailsById,
  rejectAproveCompany,
} from "../../../../redux/adminSlice";
import PdfGenerator from "../../../../components/common components/PdfMakeSample";
import DeclineModalCompanyComponent from "../../../../components/Modals/DeclineModalCompanyComponent";
import RejectCompanyModalComponent from "../../../../components/Modals/RejectCompanyModalComponent";

const ReviewPendingCompany = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isCancelModalOpen, setIsCancelModalOpen] = useState(false);

  const { companyId } = useParams();
  // const pendingCompanyDetails = []
  const pendingCompanyDetails =
    useSelector((state) => state.admin.getPendingCompanyData?.data?.[0]) || {};
  const companyCertificateDetails = useSelector(
    (state) => state.admin.certificateData
  );

  // useEffect to fetch company details
  useEffect(() => {
    console.log("companyId", companyId);
    const queryParams = { type: "pending" };
    dispatch(getPendingCompanyDetailsById({ companyId, queryParams }));
  }, [dispatch, companyId]); // Added dispatch to dependency array

  useEffect(() => {
    const queryParams = { type: "certificates", pageNumber: 1, pageSize: 12 };

    dispatch(fetchCompanyCertificateDetails({ companyId, queryParams }));
  }, [dispatch]);

  // console.log('Review Active Company ::', companyId, pendingCompanyDetails)
  const editCompanyFun = (
    companyId,
    step,
    actionType,
    pendingCompanyDetails
  ) => {
    if (step === "companyDetails") {
      navigate(`/edit-company-details/${companyId}`, {
        state: {
          actionType: "edit",
          companyId: companyId,
          pendingCompanyDetails: pendingCompanyDetails,
        },
      });
    } else if (step === "contactDetails") {
        navigate(`/edit-contact-details/${companyId}`, {
          state: {
            actionType: "edit",
            companyId: companyId,
            pendingCompanyDetails: pendingCompanyDetails,
          },
        });
    } else if (step === "userDetails") {
      navigate(`/edit-user-details/${companyId}`, {
        state: {
          actionType: "edit",
          companyId: companyId,
          pendingCompanyDetails: pendingCompanyDetails,
        },
      });
    } else if (step === "locationDetails") {
      navigate(`/edit-location-details/${companyId}`, {
        state: {
          actionType: "edit",
          companyId: companyId,
          pendingCompanyDetails: pendingCompanyDetails,
        },
      });
    } else {
      navigate(`/edit-refrred-details/${companyId}`, {
        state: {
          actionType: "edit",
          companyId: companyId,
          pendingCompanyDetails: pendingCompanyDetails,
        },
      });
    }

    // if (actionType === 'buName') {
    // navigate(`review-active-orders/${actionType}/${step}/${companyId}`,  state: { actionType: 'edit', companyId: companyId, pendingCompanyDetails: pendingCompanyDetails } )
    // } else if (actionType === 'contactName') {
    // navigate(`dit-active-orders/:actionType/:step/:companyId/${companyId}`, { state: { actionType: 'edit', companyId: companyId, pendingCompanyDetails: pendingCompanyDetails } })
    // } else {
    // navigate(`dit-active-orders/:actionType/:step/:companyId/${companyId}`, { state: { actionType: 'edit', companyId: companyId, pendingCompanyDetails: pendingCompanyDetails } })
    // }
  };
  const approveCompanyFun = () => {
    const queryParams = {
      status: 1,
      companyId: companyId,
      action: "approve",
      rejectReason: "",
    };
    dispatch(rejectAproveCompany(queryParams))
    .then((response) => {
      const queryParams = { type: "pending" };
      dispatch(getPendingCompanyDetailsById({ companyId, queryParams }));
      
      
    })
    .catch((error) => {
      console.error('Error deleting product:', error);
    });
  };
  const companyStatusBadge = (pendingCompanyDetails) => {
    // let pendingCompanyDetails = { status: 'pending' }; // Example array of objects

    if (pendingCompanyDetails.isActive === 2) {
      return <span className="badge bg-pending">Pending</span>;
    } else if (pendingCompanyDetails.isActive === 0) {
      return (
        <>
          <span className="badge bg-cancelled">Rejected </span>
          <div className="row mt-4">
            <h4>Reason</h4>
            <p>{pendingCompanyDetails.rejectedReason}</p>
          </div>
        </>
      );
    } else {
      return <span className="badge bg-pending">Approve</span>;
      ;
    }
  };
  const downloadCompanyCerFun = () => {
    console.log("Certificate download clicked");
  };

  return (
    <>
      <nav aria-label="breadcrumb" className="bread-box">
        <div>
          <h1 className="fprimary">Review User and Company </h1>
          <h5 className="">Review carefully user and company details</h5>
        </div>
        <div>
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <a href="#">Company</a>
            </li>
            <li className="breadcrumb-item active" aria-current="page">
              Review Company
            </li>
          </ol>
        </div>
      </nav>
      <div className="card mt-3 bg-stage">
        <div className="card-body">
          <div className="row">
            <div className="col-md-4">
              <h1 className="fprimary">
                Company details&nbsp;&nbsp;
                <button
                  className="icon-clay mr-2"
                  onClick={() =>
                    editCompanyFun(
                      pendingCompanyDetails.companyId,
                      "companyDetails",
                      "edit",
                      pendingCompanyDetails
                    )
                  }
                >
                  <img src={editIcon} alt="Edit Company" />
                </button>
              </h1>
            </div>
            {/* <div className="col-md-10">
                            <button className="icon-clay  &nbsp;&nbsp;mr-2" onClick={() => editCompanyFun(pendingCompanyDetails.companyBuId, 'contactName', pendingCompanyDetails)}>
                                <img src={editIcon} alt="Edit Company" />
                            </button>
                        </div> */}
          </div>
          <div className="row mt-4">
            <div className="col-md-4">
              <div className="d-flex justify-content-between indect">
                <div className="left-box w-100 border-end pe-2">
                  <p className="font-13 mb-0">Company name</p>
                  <div className="bg-slash font-14">
                    {pendingCompanyDetails.companyName}
                  </div>
                </div>
                <div className="ps-2 right-box w-100">
                  <p className="font-13 mb-0">Company type</p>
                  <div className="bg-slash font-14">
                    {pendingCompanyDetails.phoneNumber?.companyTypeName ||
                      "N/A"}
                  </div>
                </div>
              </div>
            </div>

            <div className="col-md-4">
              <div className="d-flex justify-content-between indect">
                <div className="left-box w-100 pe-2">
                  <p className="font-13 mb-0">Link Parent Organization</p>
                  <div className="bg-slash font-14">
                    {pendingCompanyDetails.parentCompanyName}
                  </div>
                  <span className="ms-2">
                    <img src={linkIcon} alt="Link" />
                  </span>
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div className="d-flex justify-content-between indect">
                <div className="ps-2 right-box w-100">
                  <p className="font-13 mb-0">URL</p>
                  <div className="bg-slash font-14">
                    {pendingCompanyDetails.url}
                  </div>
                </div>
              </div>
            </div>
            {/* <div className="col-md-12">
                            <div className="mt-3">
                                <h4 className="font-18">Order Description</h4>
                                <p className="font-13">
                                    {pendingCompanyDetails.orderDescription}
                                </p>
                            </div>
                        </div> */}
          </div>
          <div className="mt-5 ml-2">
            <h1 className="fprimary">Description</h1>
            {/* <p className='mt-4'>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec orci tellus, hendrerit quis congue non, maximus nec nisi. Vivamus porttitor turpis velit, sit amet finibus magna bibendum vel. Aenean malesuada ultricies neque, at feugiat enim commodo ut. Sed suscipit rhoncus erat, mattis facilisis orci. Ut consequat ut purus a tincidunt. Nullam sit amet convallis sapien. In accumsan ante et ante vulputate,</p> */}
            <p className="mt-4">{pendingCompanyDetails.description}</p>
          </div>
        </div>
        {/* <div className="card mt-3 bg-stage">
                <div className="card-body"> */}

        {/* </div>
            </div> */}

        <div className="card-body">
          <div className="mb-2">
            <h1 className="fprimary">
              Business Unit Name&nbsp;&nbsp;
              <button
                className="icon-clay mr-2"
                onClick={() =>
                  editCompanyFun(
                    pendingCompanyDetails.companyId,
                    "companyDetails",
                    "edit",
                    pendingCompanyDetails
                  )
                }
              >
                <img src={editIcon} alt="Edit Company" />
              </button>
            </h1>
          </div>
          <div className="row mt-4">
            <div className="col-md-4">
              <div className="d-flex justify-content-between indect">
                <div className="left-box w-100 border-end pe-2">
                  <p className="font-13 mb-0">Business unit name</p>
                  <div className="bg-slash font-14">
                    {pendingCompanyDetails.companyBuName}
                  </div>
                </div>
                <div className="ps-2 right-box w-100">
                  <p className="font-13 mb-0">Company type</p>
                  <div className="bg-slash font-14">
                    {pendingCompanyDetails.companyTypeName?.companyName || "-"}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Users detail */}
        <div className="card-body">
          <div className="mb-2">
            <h1 className="fprimary">
              User Details&nbsp;&nbsp;
              <button
                className="icon-clay mr-2"
                onClick={() =>
                  editCompanyFun(
                    pendingCompanyDetails.companyId,
                    "userDetails",
                    "edit",
                    pendingCompanyDetails
                  )
                }
              >
                <img src={editIcon} alt="Edit Company" />
              </button>
            </h1>
          </div>
          <div className="col-md-4">
            <div className="d-flex justify-content-between indect">
              <div className="left-box w-100 border-end pe-2">
                <p className="font-13 mb-0">First Name</p>
                <div className="bg-slash font-14">
                  {pendingCompanyDetails.user?.firstName}
                </div>
              </div>
              <div className="ps-2 right-box w-100">
                <p className="font-13 mb-0">Last Name</p>
                <div className="bg-slash font-14">
                  {pendingCompanyDetails.user?.lastName}
                </div>
              </div>
            </div>
          </div>
          {/* <div className="col-md-4">
            <div className="d-flex justify-content-between indect">
              <div className="left-box w-100 pe-2">
                <p className="font-13 mb-0">Last Name</p>
                <div className="bg-slash font-14">
                  {pendingCompanyDetails.user?.lastName}
                </div>
                
              </div>
            </div>
          </div> */}
        </div>
        {/* Contact Details */}
        <div className="card-body">
          <div className="mb-2">
            <h1 className="fprimary">
              Contact Details&nbsp;&nbsp;
              <button
                className="icon-clay mr-2"
                onClick={() =>
                  editCompanyFun(
                    pendingCompanyDetails.companyId,
                    "contactDetails",
                    "edit",
                    pendingCompanyDetails
                  )
                }
              >
                <img src={editIcon} alt="Edit Company" />
              </button>
            </h1>
          </div>
          <div className="row mt-4">
            <div className="col-md-4">
              <div className="d-flex justify-content-between indect">
                <div className="left-box w-100 border-end pe-2">
                  <p className="font-13 mb-0">Mobile No.</p>
                  <div className="bg-slash font-14">
                    {pendingCompanyDetails.phoneNumber}
                  </div>
                </div>
                <div className="ps-2 right-box w-100">
                  <p className="font-13 mb-0">Addition Mobile No.</p>
                  <div className="bg-slash font-14">
                    {pendingCompanyDetails.phoneNumber?.phoneNumber || "-"}
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div className="d-flex justify-content-between indect">
                <div className="left-box w-100 border-end pe-2">
                  <p className="font-13 mb-0">Email-id</p>
                  <div className="bg-slash font-14">
                    {pendingCompanyDetails.emailAddress}
                  </div>
                </div>
                <div className="ps-2 right-box w-100">
                  <p className="font-13 mb-0">Addition Email Id</p>
                  <div className="bg-slash font-14">
                    {pendingCompanyDetails.additionalEmail}
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div className="d-flex justify-content-between indect">
                <div className="left-box w-100 pe-2">
                  <p className="font-13 mb-0">GST/ VAT/ Tax id *</p>
                  <div className="bg-slash font-14">
                    {pendingCompanyDetails.linkedOrderNumber}
                  </div>
                  {/* <span className="ms-2"><img src={linkIcon} alt="Link" /></span> */}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="card-body">
          <div className="mb-2">
            <h1 className="fprimary">
              Location &nbsp;&nbsp;
              <button
                className="icon-clay mr-2"
                onClick={() =>
                  editCompanyFun(
                    pendingCompanyDetails.companyId,
                    "locationDetails",
                    "edit",
                    pendingCompanyDetails
                  )
                }
              >
                <img src={editIcon} alt="Edit Company" />
              </button>
            </h1>
          </div>
          <div className="row mt-4">
            {/* <p>Plot No. 23-24, union Vaishali Nagar, West Delhi, Delhi-110096, India</p> */}

            <p>
              {pendingCompanyDetails.address} {"\n"}
              {/* {pendingCompanyDetails.isdCode} {'\n'}
                        {pendingCompanyDetails.phoneNumber} {'\n'}
                        {pendingCompanyDetails.referredName} {'\n'}
                        {pendingCompanyDetails.referredName} {'\n'}
                        {pendingCompanyDetails.referredName} {'\n'}
                        {pendingCompanyDetails.referredName} {'\n'} */}
            </p>
          </div>
        </div>
        <div className="card-body">
          <div className="mb-2">
            <h1 className="fprimary">
              Referred By&nbsp;&nbsp;
              <button
                className="icon-clay mr-2"
                onClick={() =>
                  editCompanyFun(
                    pendingCompanyDetails.companyId,
                    "referredDetails",
                    "edit",
                    pendingCompanyDetails
                  )
                }
              >
                <img src={editIcon} alt="Edit Company" />
              </button>
            </h1>
          </div>
          <div className="row mt-4">
            <p className="">
              {pendingCompanyDetails.referredName} {"\n"}
              {pendingCompanyDetails.referredCompanyName} {"\n"}
              {pendingCompanyDetails.referredEmail} {"\n"}
              {pendingCompanyDetails.referredPhone} {"\n"}
              {pendingCompanyDetails.awards} {"\n"}
            </p>
          </div>
        </div>
      </div>
      {/* <PdfGenerator /> */}

      <hr />

      <div className="card-body mt-4">
        <div className="mb-2">
          <h1 className="fprimary">
            Current status &nbsp;&nbsp;
            {companyStatusBadge(pendingCompanyDetails)}
          </h1>
        </div>
        <div>
          {/* {pendingCompanyDetails.isActive === 1 ? 
                     <p>
                        {pendingCompanyDetails.rejectedReason}
                        <p/>
                        :
                        <></> */}
        </div>
      </div>

      <div className="d-flex justify-content-start mt-3 mb-5">
        {/* {companyDetails.isOrderPlaced !== 1 && ( */}
        {/* <button type="button" className="btn btn-light grey-btn lg-btn me-3" onClick={() => navigate - 1}>Reject */}
{/* 
        <RejectCompanyModalComponent
          isOpen={isCancelModalOpen}
          onClose={() => onClose}
          companyId={pendingCompanyDetails.companyId}
          forModule="Company"
        /> */}
        {/* </button> */}
        {/* {(pendingCompanyDetails.isActive !==1) && 
        <>
        <RejectCompanyModalComponent
          isOpen={isCancelModalOpen}
          onClose={() => onClose}
          companyId={pendingCompanyDetails.companyId}
          forModule="Company"
        />
        
        <button
          className="btn btn-primary greeen-btn lg-btn me-5"
          onClick={() =>
            approveCompanyFun(pendingCompanyDetails.companyId, "approve")
          }
        >
          Approve
        </button>
        </>} */}

        {(pendingCompanyDetails.isActive ===2) && 
        <>
        <RejectCompanyModalComponent
          isOpen={isCancelModalOpen}
          onClose={() => onClose}
          companyId={pendingCompanyDetails.companyId}
          forModule="Company"
        />
        
        <button
          className="btn btn-primary greeen-btn lg-btn me-5"
          onClick={() =>
            approveCompanyFun(pendingCompanyDetails.companyId, "approve")
          }
        >
          {/* <img src={placeOrderIcon} alt="Place Order" />   */}Approve
        </button>
        </>}
        
      </div>
    </>
  );
};

export default ReviewPendingCompany;
